export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4724.c85c9921.jpg";